import { EventType } from "../../modules/notifications/settings/notificationTriggersStore";
import moment from "moment";
import { applyFiltersToToQueryObject } from "../../util/urlSync";
import { urlQueryDefinition as reviewUrlQueryDefinition, dateRanges as reviewDateRanges } from "../../modules/reviews/ReviewFilterStore";
import { urlQueryDefinition as socialUrlQueryDefinition } from "../../modules/social/filters/SocialPostFiltersStore";
import { dateRangeOptions as socialDateRanges } from "../../modules/social/filters/SocialPostFiltersContainer"
import { stringify } from "../../util/UrlFragmentSearch";

const LinkBuilder = {
  fromTrigger(trigger) {
    switch (trigger.eventType) {
      case EventType.REVIEW_RECEIVED:
        return LinkBuilder.reviewReceived(trigger);
      case EventType.REVIEW_UPDATED:
        return LinkBuilder.reviewUpdated(trigger);
      case EventType.GOOGLE_QUESTIONS_AND_ANSWERS:
        return LinkBuilder.socialGoogleQA(trigger);
      default:
        console.warn("url not supported");
    }
  },

  reviewReceived(trigger) {
    const { range, endDate, startDate } = LinkBuilder.getReviewDate();
    const params = {
      range,
      endDate,
      startDate,
      ratings: (trigger.criteria.reviewStars || []).map(x => `${x}star`).concat(
        (trigger.criteria.reviewRecommendations || []).map(x => x.toLowerCase())
      ),
      providers: (trigger.criteria.reviewProvider || []),
      keywords: LinkBuilder.getReviewKeywords(trigger)
    };
    const baseUrl = "/#/reviews?";
    const query = {}
    applyFiltersToToQueryObject(reviewUrlQueryDefinition, params, query)
    const queryString = stringify(query);
    return baseUrl + queryString;
  },

  reviewUpdated(trigger) {
    const { range, endDate, startDate } = LinkBuilder.getReviewDate();
    const params = {
      range,
      endDate,
      startDate,
      providers: (trigger.criteria.reviewProvider || []),
      keywords: LinkBuilder.getReviewKeywords(trigger)
    };
    const baseUrl = "/#/reviews?";
    const query = {}
    applyFiltersToToQueryObject(reviewUrlQueryDefinition, params, query)
    const queryString = stringify(query);
    return `${baseUrl}${queryString}`;
  },

  getReviewKeywords(trigger){
    return trigger.criteria.keywords.map(x => `"${x}`).join(" | ") || null
  },

  getReviewDate() {
    const dateRange = reviewDateRanges.find(x => x.id === "Last30Days");
    if (!dateRange) throw new Error("date range not found. Did date ranges change?")
    return { range: dateRange.id, endDate: dateRange.to, startDate: dateRange.from };
  },

  getSocialDate() {
    const dateRange = socialDateRanges.find(x => x.dateRangeType === "month");
    if (!dateRange) throw new Error("date range not found. Did date ranges change?")
    return { dateRangeType: dateRange.dateRangeType, end: dateRange.to, start: dateRange.from };
  },

  socialGoogleQA(trigger) {
    const baseUrl = "#/social/activity?";
    const params = {
      chatterProvider: ["Google"],
      text: trigger.criteria.keywords.join("|"),
      ...LinkBuilder.getSocialDate()
    };
    const query = {};
    applyFiltersToToQueryObject(socialUrlQueryDefinition,params, query);
    const queryString = stringify(query);
    return `${baseUrl}${queryString}`;
  }
};

export default LinkBuilder;
